import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  DaySpotAndRangePicker,
  Error,
  ExportExcelContainer,
  Loading,
  MaterialTransactionProcessTable,
  ViewTitle,
} from '@iarc-programing/emanufac-components/src/components/';
import { MaterialTransactionProcessColumn } from '@iarc-programing/emanufac-utils/columns';
import { Card, CardContent } from '@mui/material';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { config } from '@/configs';
import * as actions from '@/redux/actions';
import { useQuery } from '@/utils/functions';

/**
 * @function HistoryByProcess
 * @description Display a collections or a list of HistoryByProcess from database
 */

export default function HistoryByProcess({ title, subtitle }) {
  const dispatch = useDispatch();
  const materialTransaction = useSelector((state) => state.materialTransaction);
  const history = useHistory();
  const query = useQuery();
  const [page, setPage] = useState(
    query.get('page') ? parseInt(query.get('page'), 10) : 1,
  );
  const [size, setSize] = useState(
    query.get('size') ? parseInt(query.get('size'), 10) : 10,
  );
  const [total, setTotal] = useState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const queryDataFromServer = async () => {
    try {
      dispatch(
        actions.materialTransactionAll({
          page,
          size,
          direction: 'desc',
          start: startDate ? dayjs(startDate).format('YYYY-MM-DD') : '',
          end: endDate ? dayjs(endDate).format('YYYY-MM-DD') : '',
          lookupProcess: true,
        }),
      );
    } catch (error) {
      dispatch(actions.materialTransactionError());
    }
  };

  useEffect(() => {
    queryDataFromServer();
    return () => {};
  }, [page, size, startDate, endDate]);

  useEffect(() => {
    if (materialTransaction?.total) {
      setTotal(materialTransaction.total);
    }

    return () => {};
  }, [materialTransaction]);

  const transactionAPIQuery = {
    page: 1,
    size: config.maxFetchSize,
    direction: 'desc',
    start: startDate ? dayjs(startDate).format('YYYY-MM-DD') : '',
    end: endDate ? dayjs(endDate).format('YYYY-MM-DD') : '',
    lookupProcess: true,
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  if (materialTransaction.isLoading) {
    return <Loading />;
  }
  if (!materialTransaction.isLoading && materialTransaction.isCompleted) {
    return (
      <div>
        <div className="flex justify-between items-center">
          {renderTitle()}
          <div>
            <ExportExcelContainer
              currentData={materialTransaction?.rows}
              dataAPIEndPoint="material-transaction"
              dataQuery={transactionAPIQuery}
              sheetName={`MaterialTxn-${
                startDate ? dayjs(startDate).format('YYYY-MM-DD') : ''
              }-${endDate ? dayjs(endDate).format('YYYY-MM-DD') : ''}`}
              columnList={MaterialTransactionProcessColumn}
              spreadedColumn="material_stock_lot"
            />
          </div>
        </div>
        <div>
          <Card>
            <CardContent>
              <DaySpotAndRangePicker
                addSearchQuery
                enable
                endDate={endDate}
                flex
                setEndDate={setEndDate}
                setStartDate={setStartDate}
                startDate={startDate}
                size="small"
                setParentUseRange={() => {}}
                anotherQuery={`?page=${page}&size=${size}`}
                showTypeSelector
              />
            </CardContent>
          </Card>
        </div>
        <div>
          <MaterialTransactionProcessTable
            disableDelete
            page={page}
            setPage={setPage}
            setSize={setSize}
            size={size}
            total={total}
            transaction={materialTransaction}
          />
        </div>
      </div>
    );
  }
  return <Error />;
}

HistoryByProcess.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

HistoryByProcess.defaultProps = {
  title: '',
  subtitle: '',
};
